import React from 'react';
import styles from './ClientCard.module.css';

interface ClientCardProps {
  name: string;
  logoUrl?: string;
  className?: string;
}

export const ClientCard: React.FC<ClientCardProps> = ({
  name,
  logoUrl,
  className,
}) => {
  return (
    <div className={`${styles.clientCard} ${className || ''}`}>
      <div className={styles.logoContainer}>
        {logoUrl ? (
          <img src={logoUrl} alt={`${name} logo`} className={styles.logo} />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
